import type { RefObject } from 'react';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { useComparisonMode } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { KeyMeasuresOverTime } from '../../main-section/key-measures-over-time/key-measures-over-time';
import { MeasureComparison } from '../../main-section/measure-comparison/measure-comparison';
import { MonthlyAverages } from '../../main-section/monthly-averages/monthly-averages';
import { ComparisonMode, MultipleViewMode } from '../../process-analysis.type';

export const MainSectionContent = ({ chartRef }: { chartRef: RefObject<HTMLDivElement | null> }) => {
  const multipleViewMode = useProcessAnalysisStore((state) => state.multipleViewMode);
  const comparisonMode = useComparisonMode();

  if (comparisonMode === ComparisonMode.Single) {
    return <MeasureComparison chartRef={chartRef} />;
  }

  if (comparisonMode === ComparisonMode.Multiple) {
    switch (multipleViewMode) {
      case MultipleViewMode.MonthlyAverages:
        return <MonthlyAverages />;
      case MultipleViewMode.KeyMeasuresOverTime:
        return <KeyMeasuresOverTime chartRef={chartRef} />;
      default:
        return null;
    }
  }

  return null;
};
